import { IntegrationFormFieldBuilder } from './integration-form-field-builder'
import { IntegrationFormField } from './integration-form-types'

interface IntegrationFormManagerProps {
  integrationType: string
  integrationAssignment: any
  integrationFields: IntegrationFormField[]
  assignmentMetaDataType?: string
}

export const IntegrationFormManager = ({
  integrationAssignment,
  integrationType,
  integrationFields,
  assignmentMetaDataType,
}: IntegrationFormManagerProps) => {
  const orderedFormFields = [...integrationFields].sort(
    (a, b) => a.config.placement - b.config.placement,
  )
  return (
    <div className="flex flex-col gap-4">
      {orderedFormFields.map(formField => (
        <IntegrationFormFieldBuilder
          integrationAssignment={integrationAssignment}
          integrationType={integrationType}
          field={formField}
          key={`${formField.field}-${formField.config.placement}`}
          assignmentMetaDataType={assignmentMetaDataType}
        />
      ))}
    </div>
  )
}
